module.exports = __webpack_public_path__ + "img/dfm.dccc6153.svg";